import React, {useState} from 'react'
import Carousel from 'react-bootstrap/Carousel'
import {SlideImages} from '../data'


const CarouselHeader = () => {

    return (
        <Carousel>
                <Carousel.Item>
                <img
                className="d-block w-100"
                src={SlideImages.slide1}
                alt="First slide"
                />
                <Carousel.Caption>
                <h3>First slide label</h3>
                <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
                <img
                className="d-block w-100"
                src={SlideImages.slide2}
                alt="Third slide"
                />
            
                <Carousel.Caption>
                <h3>Second slide label</h3>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
                <img
                className="d-block w-100"
                src={SlideImages.slide3}
                alt="Third slide"
                />
            
                <Carousel.Caption>
                <h3>Third slide label</h3>
                <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur.</p>
                </Carousel.Caption>
            </Carousel.Item>
        </Carousel>
    )
}

export default CarouselHeader